import SSNInput from './SSNInput'
export default SSNInput
